import { plural, t } from '@lingui/core/macro';
import { Box, Dialog, DialogContent, DialogHeader, Loader, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function ProcessingBulkUpdateDialog(props) {
    const { type, documentCount, property } = props;
    const { label: metadataProperty } = property;
    const updateTitle = t({
        message: 'Updating metadata value',
        comment: 'Bulk action: Metadata - Processing bulk update dialog title',
    });
    const clearTitle = t({
        message: 'Clearing metadata value',
        comment: 'Bulk action: Metadata - Processing bulk clear dialog title',
    });
    const updateMessage = plural(documentCount, {
        one: `Updating ${metadataProperty} for # document`,
        other: `Updating ${metadataProperty} for # documents`,
    });
    const clearMessage = plural(documentCount, {
        one: `Clearing ${metadataProperty} for # document`,
        other: `Clearing ${metadataProperty} for # documents`,
    });
    const title = type === 'update' ? updateTitle : clearTitle;
    const loadingMessage = type === 'update' ? updateMessage : clearMessage;
    return (<Dialog size="sm">
      <DialogHeader icon={<Falcon icon="tag"/>} title={title}/>
      <DialogContent>
        <Box flexDirection="column" alignItems="center" p="2xl" gap="xl" width="100%">
          <Loader size="md"/>
          <Typography $fontSize="small" $appearance="200">
            {loadingMessage}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>);
}
